import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/createTree.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import { combine, createStore } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { treeSort } from "../../../helpers";
export var currentModelsByClassifierId$ = createStore({}, {
  name: "currentModelsByClassifierId$",
  sid: "yq0eu2"
});
export function createTree(_ref) {
  var rootNodes$ = _ref.rootNodes$,
      flatNodes$ = _ref.flatNodes$;
  var tree$ = combine({
    ɔ: [{
      rootNodes: rootNodes$,
      flatNodes: flatNodes$,
      currentModels: currentModelsByClassifierId$
    }, function (_ref2) {
      var rootNodes = _ref2.rootNodes,
          currentModels = _ref2.currentModels,
          flatNodes = _ref2.flatNodes;

      var createNode = function createNode(node) {
        switch (node.type) {
          case 'ModelRepositoryFolderNode':
            {
              var type = 'ModelRepoFolderTreeNode';
              var children = flatNodes.filter(function (_ref3) {
                var parentFolderUrn = _ref3.parentFolderUrn;
                return parentFolderUrn === node.urn;
              }).map(createNode).filter(isNotEmpty);
              return _objectSpread(_objectSpread({}, node), {}, {
                type: type,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                children: children
              });
            }

          case 'BimFileNode':
            {
              var _type = 'BimFileTreeNode';
              var baseClassifierId = node.baseClassifierId;

              var getVersions = function getVersions() {
                var currentModel = baseClassifierId ? currentModels[baseClassifierId] : null;
                var latestVersion = {
                  urn: buildModelsTreeKey({
                    urn: node.urn,
                    version: node.versionId
                  }),
                  type: 'BimFileVersionTreeNode',
                  versionId: node.versionId,
                  versionName: node.versionName,
                  status: node.status,
                  author: node.author,
                  uploadDate: node.uploadDate,
                  isCurrent: false,
                  name: node.name
                };

                if (currentModel) {
                  var _currentModel$forgeDa, _currentModel$forgeDa2;

                  if (node.versionId === ((_currentModel$forgeDa = currentModel.forgeData) === null || _currentModel$forgeDa === void 0 ? void 0 : _currentModel$forgeDa.forgeVersion)) {
                    return [_objectSpread(_objectSpread({}, latestVersion), {}, {
                      isCurrent: true
                    })];
                  }

                  return [latestVersion, {
                    urn: buildModelsTreeKey({
                      urn: node.urn,
                      version: currentModel.version
                    }),
                    type: 'BimFileVersionTreeNode',
                    versionId: currentModel.version,
                    versionName: ((_currentModel$forgeDa2 = currentModel.forgeData) === null || _currentModel$forgeDa2 === void 0 ? void 0 : _currentModel$forgeDa2.forgeVersionName) || 0,
                    status: currentModel.status,
                    author: currentModel.author,
                    uploadDate: currentModel.uploadDate,
                    name: currentModel.name,
                    isCurrent: true
                  }];
                }

                return [latestVersion];
              };

              return _objectSpread(_objectSpread({}, node), {}, {
                type: _type,
                children: getVersions()
              });
            }

          default:
            return null;
        }
      };

      var tree = rootNodes.map(createNode).filter(isNotEmpty);
      return treeSort({
        data: tree,
        itemKey: 'type',
        priorityItemKeyValues: ['ModelRepoFolderTreeNode']
      });
    }],
    config: {
      name: "tree$",
      sid: "m98nr7"
    }
  });
  return tree$;
}
export function buildModelsTreeKey(_ref4) {
  var urn = _ref4.urn,
      version = _ref4.version;
  return "".concat(urn).concat(version);
}